import { ColorlessIconProps } from './types';

/**
 * Компонент для отрисовки пустой иконки (резервации пространства под неё)
 */
export const EmptyIcon = function EmptyIcon(props: ColorlessIconProps) {
    // убираем библиотечные свойства из svg, чтобы не триггерить warning
    const { size, role, viewBox, color, title, ...restProps } = props;

    return (
        <svg
            {...restProps}
            width={size}
            height={size}
            viewBox={viewBox}
            fill="none"
            focusable="false"
            aria-hidden="true"
        >
            {title && <title>{title}</title>}
        </svg>
    );
};
